export const SET_SETTING_WA = 'WA/SET_SETTING_WA'
